// GENERATED by scripts/compute_bereich_areas.py — do not edit by hand.
// Mapped area per Bereich, unioned from the static region polygons so
// overlapping layers never double-count. Regions appear here once their
// polygons are trusted enough to publish an area for.
export const COMPUTED_AREAS = {
  "Franken": {
    "generated": "2026-08-24",
    "totalHa": 6648.2,
    "bereiche": [
      {
        "name": "Volkacher Mainschleife",
        "ha": 2158.5
      },
      {
        "name": "MainSüden",
        "ha": 1349.4
      },
      {
        "name": "Schwanberger Land",
        "ha": 834.0
      },
      {
        "name": "Mittelmain",
        "ha": 740.1
      },
      {
        "name": "Weinparadies",
        "ha": 320.7
      },
      {
        "name": "Churfranken",
        "ha": 315.5
      },
      {
        "name": "Weinpanorama Steigerwald",
        "ha": 299.7
      },
      {
        "name": "Mittelfränkische Bocksbeutelstraße",
        "ha": 176.8
      },
      {
        "name": "Main Himmelreich",
        "ha": 134.8
      },
      {
        "name": "Frankens Saalestück",
        "ha": 126.4
      },
      {
        "name": "Alzenauer Weinregion",
        "ha": 97.3
      },
      {
        "name": "Abt Degen Weintal",
        "ha": 87.8
      }
    ]
  },
  "Ahr": {
    "generated": "2026-08-24",
    "totalHa": 955.1,
    "bereiche": [
      {
        "name": "Walporzheim/Ahrtal",
        "ha": 955.1
      }
    ]
  },
  "Baden": {
    "generated": "2026-08-24",
    "totalHa": 17324.5,
    "bereiche": [
      {
        "name": "Kaiserstuhl",
        "ha": 4530.1
      },
      {
        "name": "Markgräflerland",
        "ha": 3494.2
      },
      {
        "name": "Ortenau",
        "ha": 2880.3
      },
      {
        "name": "Breisgau",
        "ha": 2009.8
      },
      {
        "name": "Kraichgau",
        "ha": 1476.9
      },
      {
        "name": "Tuniberg",
        "ha": 1165.8
      },
      {
        "name": "Tauberfranken",
        "ha": 714.8
      },
      {
        "name": "Bodensee",
        "ha": 596.2
      },
      {
        "name": "Badische Bergstraße",
        "ha": 456.4
      }
    ]
  },
  "Hessische Bergstraße": {
    "generated": "2026-08-24",
    "totalHa": 556.9,
    "bereiche": [
      {
        "name": "Starkenburg",
        "ha": 450.6
      },
      {
        "name": "Umstadt",
        "ha": 106.3
      }
    ]
  },
  "Mittelrhein": {
    "generated": "2026-08-24",
    "totalHa": 737.0,
    "bereiche": [
      {
        "name": "Loreley",
        "ha": 715.8
      },
      {
        "name": "Siebengebirge",
        "ha": 21.1
      }
    ]
  },
  "Mosel": {
    "generated": "2026-08-24",
    "totalHa": 9203.7,
    "bereiche": [
      {
        "name": "Bernkastel",
        "ha": 5927.0
      },
      {
        "name": "Burg Cochem",
        "ha": 1329.8
      },
      {
        "name": "Saar",
        "ha": 902.4
      },
      {
        "name": "Obermosel",
        "ha": 745.1
      },
      {
        "name": "Ruwer",
        "ha": 234.1
      },
      {
        "name": "Moseltor",
        "ha": 65.3
      }
    ]
  },
  "Nahe": {
    "generated": "2026-08-24",
    "totalHa": 4775.3,
    "bereiche": [
      {
        "name": "Nahetal",
        "ha": 4775.3
      }
    ]
  },
  "Pfalz": {
    "generated": "2026-08-24",
    "totalHa": 25632.1,
    "bereiche": [
      {
        "name": "Südliche Weinstraße",
        "ha": 15742.5
      },
      {
        "name": "Mittelhaardt/Deutsche Weinstraße",
        "ha": 9878.7
      }
    ]
  },
  "Rheingau": {
    "generated": "2026-08-24",
    "totalHa": 3199.4,
    "bereiche": [
      {
        "name": "Johannisberg",
        "ha": 3199.4
      }
    ]
  },
  "Rheinhessen": {
    "generated": "2026-08-24",
    "totalHa": 26666.6,
    "bereiche": [
      {
        "name": "Nierstein",
        "ha": 9216.9
      },
      {
        "name": "Bingen",
        "ha": 8846.2
      },
      {
        "name": "Wonnegau",
        "ha": 8604.0
      }
    ]
  },
  "Saale-Unstrut": {
    "generated": "2026-08-24",
    "totalHa": 782.5,
    "bereiche": [
      {
        "name": "Schloss Neuenburg",
        "ha": 541.3
      },
      {
        "name": "Thüringen",
        "ha": 141.0
      },
      {
        "name": "Mansfelder Seen",
        "ha": 85.6
      },
      {
        "name": "Werder/Havel",
        "ha": 10.9
      }
    ]
  },
  "Sachsen": {
    "generated": "2026-08-24",
    "totalHa": 511.3,
    "bereiche": [
      {
        "name": "Meißen",
        "ha": 479.4
      },
      {
        "name": "Elstertal",
        "ha": 31.2
      }
    ]
  },
  "Württemberg": {
    "generated": "2026-08-24",
    "totalHa": 12913.4,
    "bereiche": [
      {
        "name": "Württembergisch Unterland",
        "ha": 10305.0
      },
      {
        "name": "Remstal",
        "ha": 1885.3
      },
      {
        "name": "Kocher-Jagst-Tauber",
        "ha": 515.6
      },
      {
        "name": "Neckar-Alb",
        "ha": 124.3
      },
      {
        "name": "Württembergischer Bodensee",
        "ha": 66.1
      },
      {
        "name": "Bayerischer Bodensee",
        "ha": 12.8
      }
    ]
  }
};
